import { TabProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export default function Tabs(theme: Theme) {
  const { fontSize, lineHeight } = theme.typography.body2;

  return {
    MuiTabs: {
      defaultProps: {
        textColor: 'inherit',
        allowScrollButtonsMobile: true,
        variant: 'scrollable',
      },
      styleOverrides: {
        scrollButtons: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
        iconPosition: 'start',
      },
      styleOverrides: {
        root: ({ ownerState }: { ownerState: TabProps }) => ({
          padding: 0,
          opacity: 1,
          minWidth: 48,
          // MUI's Tab spreads `typography.button` and then hardcodes `lineHeight: 1.25` after it, so
          // the font both tab levels share cannot be inherited and has to be declared here.
          fontSize,
          lineHeight,
          fontWeight: theme.typography.fontWeightMedium,
          // `typography.button` capitalizes every word, which fights the sentence-case tab labels the
          // translations are written in.
          textTransform: 'none',
          '&:not(:last-of-type)': {
            marginRight: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
              marginRight: theme.spacing(5),
            },
          },
          '&:not(.Mui-selected)': {
            color: theme.palette.text.secondary,
          },
          ...((ownerState.iconPosition === 'start' || ownerState.iconPosition === 'end') && {
            minHeight: 48,
          }),
        }),
      },
    },
  };
}
